import React from 'react';
import logo from '../../assets/img/logo.png';
import register from '../../assets/img/signup.png'
import '../../assets/css/login.css';
import '../../assets/css/bootstrap.css';
import { useHistory } from 'react-router';

const EmailConfirmation = () => {
    const history = useHistory();

    const handleLogin = () => {
        history.push('/account/login');
    }

    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6 login-section-wrapper">
                        <div className="brand-wrapper">
                            <img src={logo} alt="" className="logo" />
                            <h1 className="login-title">Create Account</h1>
                        </div>
                        <p>Please Check your email inbox for a verification link</p>
                    </div>

                    <div className="col-sm-6 px-0 d-none d-sm-block">
                        <img src={register} alt="" className="login-img" />
                    </div>
                </div>	
            </div>
        </div>
    );
};

export default EmailConfirmation;